<template>
  <div class="container-fluid">
    <div class="card mb-4">
      <div class="card-body">
        <form class="row g-3">
          <div class="col-md-4">
            <label class="form-label">Store :</label>
            <v-select
              v-model="store_filter"
              label="name"
              :options="clientList"
              @search="filterClients"
            />
          </div>
          <div class="col-md-4">
            <label class="form-label">Statut:</label>
            <select v-model="status_filter" class="form-select">
              <option value="" selected>Status (Tous)</option>
              <option :value="4">Vide</option>
              <option :value="0" selected>Nouveau</option>
              <option :value="1" selected>En attente d'expédition</option>
              <option :value="2">Expédié</option>
              <option :value="3">Reçu</option>
            </select>
          </div>
          <!--<div class="col-md-4">
            <label class="form-label">Statut-Auto/normal:</label>
            <select v-model="status_auto_filter" class="form-select">
              <option value="" selected>Status (Tous)</option>
              <option :value="0" selected>Automatique</option>
              <option :value="1" selected>Normal</option>
            </select>
          </div>
           <div class="col-md-4">
            <label class="form-label">Ville :</label>
            <v-select
              v-model="city_filter"
              label="name"
              :options="CitiesList"
            />
          </div>
          <div class="col-md-4">
            <label class="form-label">Créer par :</label>
            <v-select
              v-model="user_filter"
              label="name"
              :options="UsersList"
              @search="onSearchUsers"
            >
             
            </v-select>
          </div>
          <div class="col-md-4">
            <label class="form-label">Par Date :</label>
            
          </div>
          <div class="col-md-4">
            <label class="form-label">Date de validation :</label>
           
          </div> -->
          <div class="col-md-4 d-flex align-items-end">
            <button
              type="button"
              class="btn btn-primary me-2"
              @click="filter()"
            >
              <feather-icon icon="FilterIcon" size="16" />
              Filtrer
            </button>
            <button
              type="button"
              class="btn btn-danger me-2"
              @click="Removefilter()"
            >
              <feather-icon icon="XIcon" size="16" />
              Annuler
            </button>
            <button
              v-if="auth.can('EXPORT_RETOUR')"
              type="button"
              class="btn btn-success"
              @click="ExportNotes()"
            >
              <feather-icon icon="FileTextIcon" size="16" />
              Exporter
            </button>
          </div>
        </form>
      </div>
    </div>

    <div class="card mb-4">
      <div class="card-header">
        <h5>Reçu Colis</h5>
      </div>
      <div class="card-body">
        <form class="row g-3" @submit.prevent="ScanRecuColis">
          <div class="col-md-9">
            <label class="form-label">Code Suivi :</label>
            <input
              v-model="codeColis"
              placeholder="Code Suivi"
              type="text"
              class="form-control"
            />
          </div>
          <div class="col-md-3 d-flex align-items-end">
            <button type="submit" class="btn btn-success">
              <i class="ph ph-scan"></i>
            </button>
          </div>
          <div class="col-12">
            <hr />
          </div>
        </form>
      </div>
    </div>

    <div class="card">
      <div class="card-body">
        <div class="row mb-3">
          <div class="col-md-6 d-flex align-items-center">
            <label class="me-2">Voir</label>
            <v-select
              v-model="users.per_page"
              :options="[10, 25, 50, 100]"
              :clearable="false"
              class="me-2"
              @update:modelValue="getRecords()"
            />
            <label>sur {{ users.total }} entités</label>
          </div>
          <div class="col-md-6 d-flex justify-content-end align-items-center">
            <input
              v-model="searchTerm"
              class="form-control me-2"
              placeholder="Chercher"
              @change="filter()"
              @input="handleInput"
            />
            <router-link
              v-if="auth.can('ADD_BR_C')"
              class="btn btn-primary"
              :to="{ name: 'AddReturnPage' }"
            >
              <span class="text-nowrap"> Ajouter Bon de Retour (Client)</span>
            </router-link>
          </div>
        </div>

        <vue-good-table :columns="columns" :rows="rows" responsive>
          <template #emptystate>
            <center>Aucune entrées correspondants trouvés</center>
          </template>
          <template v-slot:table-row="props">
            <span v-if="props.column.field === 'note_ref'" class="text-nowrap">
              <b>{{ props.row.note_ref }}</b
              ><br />
              <span
                v-if="props.row.is_auto && props.row.is_auto == 1"
                class="badge fs-20 bg-danger"
              >
                Automatique
              </span>
            </span>
            <span
              v-else-if="props.column.field === 'for_name'"
              class="text-nowrap"
            >
              <b v-if="props.row.magasin">
                {{ props.row.magasin.market_name }} </b
              ><br />
              {{ props.row.for_name }}
            </span>
            <span
              v-else-if="props.column.field === 'client'"
              class="text-nowrap"
            >
              <strong v-if="props.row && props.row.client">
                {{ props.row.client.store ?? props.row.client.store }}
              </strong>
              <template v-if="props.row.client.return_city">
                Retour : <b>{{ props.row.client.return_city.name }}</b>
              </template>
            </span>
            <span
              v-else-if="props.column.field === 'created_at'"
              class="text-nowrap"
            >
              <template v-if="props.row.created_at != null">
                {{ getDate(props.row.created_at) }} </template
              ><br />
              {{ props.row.by_name }}
            </span>
            <span
              v-else-if="props.column.field === 'validate_time'"
              class="text-nowrap"
            >
              <template v-if="props.row.validate_time != null">
                {{ getDate(props.row.validate_time) }}
              </template>
              <template
                v-if="props.row.duration_days && props.row.duration_days != ''"
              >
                {{ numberPars(props.row.duration_days) }} jours
              </template>
            </span>
            <span v-else-if="props.column.field === 'reçu'" class="text-nowrap">
              <h5 v-if="props.row.reçu == 2">1</h5>
              <h5 v-else>0</h5>
            </span>
            <template v-else-if="props.column.field === 'statut'">
              <span
                v-if="props.row.statut == 0"
                :class="`badge rounded-pill fs-13 text-bg-${resolveUserStatusVariant(
                  props.row.statut
                )}`"
                class="text-capitalize"
              >
                Nouveau
              </span>
              <span
                v-else-if="props.row.statut == 1"
                :class="`badge rounded-pill fs-13 text-bg-${resolveUserStatusVariant(
                  props.row.statut
                )}`"
                class="text-capitalize"
              >
                En attenete d'expédition
              </span>
              <span
                v-else-if="props.row.statut == 2"
                :class="`badge rounded-pill fs-13 text-bg-${resolveUserStatusVariant(
                  props.row.statut
                )}`"
                class="text-capitalize"
              >
                Expédier vers client
              </span>
              <span
                v-else-if="props.row.statut == 3"
                :class="`badge rounded-pill fs-13 text-bg-${resolveUserStatusVariant(
                  props.row.statut
                )}`"
                class="text-capitalize"
              >
                Reçu par client
              </span>
            </template>
            <template v-else-if="props.column.field === 'action'">
              <div class="dropdown">
                <button
                  class="dropdown-toggle card-dot-btn lh-1 position-relative top-4 bg-transparent border-0 shadow-none p-0 transition"
                  type="button"
                  data-bs-toggle="dropdown"
                  aria-expanded="false"
                >
                  <i class="flaticon-dots"></i>
                </button>
                <ul class="dropdown-menu">
                  <li
                    v-if="
                      auth.can('BR_C') &&
                      props.row.statut == 0 &&
                      props.row.total_parcel != 0
                    "
                  >
                    <a
                      class="dropdown-item"
                      href="#"
                      @click="sentNoteAuto(props.row)"
                    >
                      <i class="flaticon-send me-1"></i> Attente d'expédition
                    </a>
                  </li>
                  <li v-if="auth.can('BR_C')">
                    <a
                      class="dropdown-item"
                      href="#"
                      @click="showNote(props.row)"
                    >
                      <i class="flaticon-eye me-1"></i> Détails
                    </a>
                  </li>
                  <li v-if="auth.can('BR_C')">
                    <a
                      class="dropdown-item"
                      href="#"
                      @click="
                        $router.push(
                          `/edit-return-client/${props.row.id}/${props.row.note_ref}`
                        )
                      "
                    >
                      <i class="flaticon-edit me-1"></i> Modifier
                    </a>
                  </li>
                  <li
                    v-if="
                      auth.can('BR_C') &&
                      props.row.statut == 0 &&
                      props.row.total_parcel == 0
                    "
                  >
                    <a
                      class="dropdown-item"
                      href="#"
                      @click="DeleteNote(props.row)"
                    >
                      <i class="flaticon-trash me-1"></i> Supprimer
                    </a>
                  </li>
                  <li
                    v-if="
                      auth.can('BR_C') &&
                      props.row.statut == 1 &&
                      props.row.total_parcel != 0
                    "
                  >
                    <a
                      class="dropdown-item"
                      href="#"
                      @click="Expedier(props.row.id)"
                    >
                      <i class="flaticon-express-delivery me-1"></i> Expédier
                    </a>
                  </li>
                  <li
                    v-if="
                      auth.can('BR_C') &&
                      props.row.statut == 2 &&
                      props.row.total_parcel != 0
                    "
                  >
                    <a
                      class="dropdown-item"
                      href="#"
                      @click="RecievedBonDirect(props.row)"
                    >
                      <i class="flaticon-check me-1"></i> Reçu Directe
                    </a>
                  </li>
                  <li>
                    <a
                      class="dropdown-item"
                      href="#"
                      @click="GetPDF(props.row)"
                    >
                      <i class="flaticon-download me-1"></i> Télécharger
                    </a>
                  </li>
                  <!-- <li>
                    <router-link
                      class="dropdown-item"
                      :to="{
                        name: 'timeline-return',
                        params: { id: props.row.id, refNote: props.row.note_ref },
                      }"
                      title="Historique bon"
                    >
                      <i class="flaticon-clock me-1"></i> Historique
                    </router-link>
                  </li> -->
                </ul>
              </div>
            </template>
            <span v-else>
              {{ props.formattedRow[props.column.field] }}
            </span>
          </template>
        </vue-good-table>
        <PaginatorContent
          :pagination="users"
          :offset="9"
          @paginate="getRecords"
        />
      </div>
    </div>
  </div>

  <div
    class="modal fade"
    id="modal_detail_note"
    tabindex="-1"
    aria-hidden="true"
  >
    <div class="modal-dialog modal-dialog-centered modal-xl">
      <div class="modal-content p-15 p-md-40">
        <div class="modal-header">
          <h5 class="modal-title">Détails du bon {{ rowNote.note_ref }}</h5>
          <button
            type="button"
            class="btn-close"
            data-bs-dismiss="modal"
            aria-label="Fermer"
          ></button>
        </div>
        <div class="modal-body">
          <ShowReturnNoteC
            v-if="rowNote"
            :rowNote="rowNote"
            :getRecords="getRecords"
            :isOpen="isOpen"
          />
        </div>
      </div>
    </div>
  </div>
</template>


<script lang="ts">
import api from "@/utils/axios";
import moment from "moment";
import Swal from "sweetalert2";
import { defineComponent, reactive, ref, nextTick } from "vue";
import { useAppToast } from "@/composables/useAppToast";
import { useAuthStore } from "@/stores/auth";
import { onMounted } from "vue";
import { Modal } from "bootstrap";
import ShowReturnNoteC from "@/components/Notes/Return/Client/ShowReturnNoteC.vue";

export default defineComponent({
  name: "ReturnListe",
  components: { ShowReturnNoteC },
  setup() {
    const { showToast } = useAppToast();
    const auth = useAuthStore();
    const user = auth.user;
    // Imports
    // Refs and reactive state
    const isLoader = ref(false);
    const pageLength = ref(10);
    const loading = ref(false);
    const searchTerm = ref("");
    const columns = [
      { label: "Référence", field: "note_ref" },
      { label: "Date de création", field: "created_at" },
      // { label: "Store", field: "for_name" },
      { label: "Magasin", field: "client" },
      { label: "Statut", field: "statut" },
      { label: "Colis", field: "total_parcel" },
      { label: "Date de validation", field: "validate_time" },
      { label: "Actions", field: "action", width: "180px" },
    ];
    const rows = ref([]);
    const ZonesList = ref([]);
    const clientList = ref([]);
    const zone_filter = ref({ id: "", name: "" });
    const store_filter = ref({ id: "", name: "" });
    const UsersList = ref([]);
    const user_filter = ref({ id: "", name: "" });
    const CitiesList = ref([]);
    const city_filter = ref({ id: "", name: "" });
    const status_filter = ref("");
    const status_auto_filter = ref("");
    const date_filter = ref("");
    const duration = ref("");
    const users = reactive({
      searchTerm: "",
      searchUser: "",
      searchZone: "",
      searchStatut: "",
      searchStatutAuto: "",
      searchCity: "",
      searchEDate: "",
      searchSDate: "",
      searchStore: "",
      searchvSDate: "",
      searchvEDate: "",
      searchDuration: "",
      total: 0,
      per_page: 10,
      from: 1,
      to: 0,
      current_page: 1,
    });
    const offset = ref(9);
    const codeColis = ref("");
    let searchTimeout = null;
    let debounceTimer = null;
    const rowNote = ref<any>({});
    const isOpen = ref(false);

    const myInput = ref();
    const myInputValidate = ref();

    // Methods
    function numberPars(x) {
      let sum = parseFloat(x);
      return sum.toFixed(2);
    }

    function showNote(note) {
      rowNote.value = note;

      nextTick(() => {
        const modalEl = document.getElementById("modal_detail_note");
        console.log(modalEl);
        if (modalEl) {
          isOpen.value = true; // triggers watcher in child

          const modal = new Modal(modalEl);
          modal.show();
        }
      });
    }

    function onSearchUsers(search, loadingFn) {
      if (search.length && UsersList.value.length === 0) {
        loadingFn(true);
        api.get(`/api/auth/SelectList`).then((response) => {
          UsersList.value = response.data;
          UsersList.value.unshift({ id: "", name: "Tous" });
          loadingFn(false);
        });
      }
    }

    function getDate(value) {
      return moment(String(value)).format("YYYY-MM-DD HH:mm");
    }

    function resolveUserStatusVariant(status) {
      if (status === 0 || status === "0") return "danger";
      if (status === 1 || status === "1") return "info";
      if (status === 2 || status === "2") return "warning";
      if (status === 3 || status === "3") return "success";
      return "warning";
    }

    function convert(str) {
      const date = new Date(str);
      const mnth = `0${date.getMonth() + 1}`.slice(-2);
      const day = `0${date.getDate()}`.slice(-2);
      return [date.getFullYear(), mnth, day].join("-");
    }

    function filter() {
      users.searchZone = zone_filter.value.id;
      users.searchUser = user_filter.value.id;
      users.searchStore = store_filter.value.id;
      users.searchStatut = status_filter.value;
      users.searchStatutAuto = status_auto_filter.value;
      users.searchCity = city_filter.value.id;
      
      // users.searchDuration = duration.value;
      users.current_page = 1;
      getRecords();
    }

    function Removefilter() {
      users.searchZone =
        users.searchUser =
        users.searchStore =
        users.searchStatut =
        users.searchStatutAuto =
        users.searchSDate =
        users.searchEDate =
        users.searchvSDate =
        users.searchvEDate =
        users.searchTerm =
        users.searchCity =
          "";
      status_filter.value =
        status_auto_filter.value =
        date_filter.value =
        users.searchDuration =
          "";
      zone_filter.value =
        store_filter.value =
        user_filter.value =
        city_filter.value =
          {
            id: "",
            name: "",
          };
      if (myInput.value) myInput.value.dateRange = {};
      if (myInputValidate.value) myInputValidate.value.dateRange = {};
      users.current_page = 1;
      duration.value = "";
      getRecords();
    }

    function handleInput() {
      clearTimeout(debounceTimer);
      debounceTimer = setTimeout(() => {
        if (!searchTerm.value || searchTerm.value === "") {
          users.searchTerm = searchTerm.value;
          filter();
        } else if (searchTerm.value && searchTerm.value.length > 2) {
          users.searchTerm = searchTerm.value;
          filter();
        }
      }, 500);
    }

    function getRecords(page = 1) {
      isLoader.value = true;
      users.current_page = page;
      api
        .get(
          `/api/auth/brn_ag_list?searchTerm=${users.searchTerm}&searchUser=${users.searchUser}&searchCity=${users.searchCity}&searchZone=${users.searchZone}&searchStore=${users.searchStore}&searchStatut=${users.searchStatut}&searchStatutAuto=${users.searchStatutAuto}&searchSDate=${users.searchSDate}&searchvEDate=${users.searchvEDate}&searchvSDate=${users.searchvSDate}&searchEDate=${users.searchEDate}&searchDuration=${users.searchDuration}&page=${users.current_page}&per_page=${users.per_page}`,
          { params: { type: 2 } }
        )
        .then((response) => {
          rows.value = response.data.users.data;
          Object.assign(users, response.data.users);
          isLoader.value = false;
        });
    }

    onMounted(async () => {
      getRecords();
    });

    // Inside setup()
    function DestroyBrc(brc: any) {
      const data = new FormData();
      data.append(
        "UserID",
        String(auth.user?.id ?? "")
      );
      data.append("reception_note_id", brc.id);
      data.append("cstmr_id", brc.note_customer);
      // Implement API call if needed
    }

    function RecievedBon(row: any) {
      Swal.fire({
        text: "Vous voulez transformer ce bon ?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Oui, transformer!",
      }).then((result: any) => {
        if (result.value) {
          api
            .post(`/api/auth/Received_rn_c/${row.id}`)
            .then((res) => {
              if (res.data.message == "success") {
                filter();

                showToast("le bon est bien modifié", "success");
              } else if (
                res.data.message == "not exist" ||
                res.data.message == "no parcel"
              ) {
                showToast("Vous pouvez pas enregistré ce bon", "error");
              } else {
                showToast("Un erreur ! ", "error");
              }
            })
            .catch(() => {
              showToast("Something went wrong! Pleaz try again", "error");
            });
        }
      });
    }

    function RecievedBonDirect(row: any) {
      Swal.fire({
        text: "Vous voulez transformer ce bon (Reçu par client directement) ?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Oui, transformer!",
      }).then((result: any) => {
        if (result.value) {
          api
            .post(`/api/auth/ReceivedDirect_rn_c/${row.id}`)
            .then((res) => {
              if (res.data.message == "success") {
                filter();

                showToast("le bon est bien modifié", "success");
              } else if (
                res.data.message == "not exist" ||
                res.data.message == "no parcel"
              ) {
                showToast("Vous pouvez pas enregistré ce bon", "error");
              } else {
                showToast("Un erreur ! ", "error");
              }
            })
            .catch(() => {
              showToast("Something went wrong! Pleaz try again", "error");
            });
        }
      });
    }

    function OpenBon(row: any) {
      api
        .post(`/api/auth/unsave_rn_c/${row.id}`)
        .then((res) => {
          if (res.data.message == "success") {
            showToast("le bon est bien modifié", "success");
            filter();
          } else if (
            res.data.message == "not exist" ||
            res.data.message == "no edit" ||
            res.data.message == "no parcels"
          ) {
            showToast("Vous pouvez pas transformer ce bon", "error");
          } else {
            showToast("Un erreur ! ", "error");
          }
        })
        .catch(() => {
          showToast("Something went wrong! Pleaz try again", "error");
        });
    }

    function SaveBon(row: any) {
      api
        .post(`/api/auth/save_rn_c/${row.id}`)
        .then((res) => {
          if (res.data.message == "success") {
            filter();
          } else if (
            res.data.message == "not exist" ||
            res.data.message == "no parcel"
          ) {
            showToast("Vous pouvez pas transformer ce bon", "error");
          } else {
            showToast("Un erreur ! ", "error");
          }
        })
        .catch(() => {
          showToast("Something went wrong! Pleaz try again", "error");
        });
    }

    function GetPDF(row: any) {
      api
        .get(`/api/auth/ReturnPDF/${row.id}`, {
          responseType: "arraybuffer",
        })
        .then((response) => {
          const blob = new Blob([response.data], { type: "application/pdf" });
          const link = document.createElement("a");
          link.href = window.URL.createObjectURL(blob);
          window.open(link.href, "_blank");
        });
    }

    function DeleteNote(row: any) {
      Swal.fire({
        text: "Vous voulez vraiment supprimer ce bon ?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Oui, supprimer!",
      }).then((result: any) => {
        if (result.value) {
          api
            .post(`/api/auth/RemoveNoteRN/${row.id}/${row.note_ref}`)
            .then((res) => {
              if (res.data.message == "success") {
                filter();

                showToast("le bon est bien supprimé", "success");
              } else if (res.data.message == "not exist") {
                showToast("Vous pouvez pas supprimer ce bon!", "error");
              } else if (res.data.message == "no edit") {
                showToast("Vous pouvez pas supprimer ce bon!", "error");
              }
            })
            .catch(() => {
              showToast("Something went wrong! Pleaz try again", "error");
            });
        }
      });
    }

    function ScanRecuColis() {
      const data = new FormData();
      data.append("code_colis", codeColis.value);
      api
        .post(`/api/auth/globalScanColis2`, data)
        .then((res) => {
          codeColis.value = "";
          if (res.data.message == "success") {
            filter();
            const audio = new Audio("/sound.mp3");
          audio.play();

            showToast("Colis est bien ajouté", "success");
          } else if (res.data.message == "not exist") {
            const audio = new Audio("/erro.mp3");
            audio.play();

            showToast("Colis n'existe pas", "error");
          } else {
            const audio = new Audio("/erro.mp3");
            audio.play();

            showToast("Vous pouvez pas ajouter ce colis", "error");
          }
        })
        .catch(() => {
          showToast("Something went wrong! Pleaz try again", "error");
        });
    }

    function ExportNotes() {
      users.searchZone = zone_filter.value.id;
      users.searchUser = user_filter.value.id;
      users.searchStore = store_filter.value.id;
      users.searchStatut = status_filter.value;
      users.searchSDate =
        myInput.value?.dateRange?.start === undefined
          ? ""
          : convert(myInput.value.dateRange.start);
      users.searchEDate =
        myInput.value?.dateRange?.end === undefined
          ? ""
          : convert(myInput.value.dateRange.end);
      api
        .get(
          `/api/auth/exportReturns?searchTerm=${users.searchTerm}&searchUser=${
            users.searchUser
          }&searchZone=${users.searchZone}&searchStore=${
            users.searchStore
          }&searchStatut=${users.searchStatut}&searchSDate=${
            users.searchSDate
          }&searchEDate=${users.searchEDate}&type=${2}`,
          { responseType: "arraybuffer" }
        )
        .then((res) => {
          const fileURL = window.URL.createObjectURL(
            new Blob([res.data], {
              type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
            })
          );
          const fileLink = document.createElement("a");
          fileLink.href = fileURL;
          fileLink.download = "ExportReturns.xlsx";
          fileLink.click();
        });
    }

    function sentNoteAuto(row: any) {
      api
        .post(`/api/auth/sentNoteAuto/${row.id}`)
        .then((res) => {
          if (res.data.message == "success") {
            filter();

            showToast("le bon est bien modifié", "success");
          } else if (
            res.data.message == "not exist" ||
            res.data.message == "no parcel"
          ) {
            showToast("Vous pouvez pas transformer ce bon", "error");
          } else {
            showToast("Un erreur ! ", "error");
          }
        })
        .catch(() => {
          showToast("Something went wrong! Pleaz try again", "error");
        });
    }

    function Expedier(id: string) {
      if (id) {
        let data = new FormData();
        data.append(
          "UserID",
          String(auth.user?.id ?? "")
        );
        data.append("note_id", id);
        api
          .post(`/api/auth/sentReturnC`, data)
          .then((res) => {
            if (res.data.message == "success") {
              filter();

              showToast("Bon est bien expédié", "success");
            } else if (res.data.message == "error transport") {
              showToast("Vous devez ajouter un transporteur", "error");
            } else {
              showToast("Vous pouvez pas expédier ce bon", "error");
            }
          })
          .catch(() => {
            showToast("Something went wrong! Pleaz try again", "error");
          });
      } else {
        showToast("Something went wrong! Pleaz try again", "error");
      }
    }


    let debounceTimeout: number | undefined;
    async function filterClients(search: string, loading: { value: boolean }) {
      const query = search.trim().toLowerCase();

      if (!query) {
        clientList.value = [];
        return;
      }

      // Debounce to avoid too many API calls
      if (debounceTimeout) clearTimeout(debounceTimeout);

      debounceTimeout = window.setTimeout(async () => {
        try {
          const res = await api.get(`/api/auth/ListCustsFilter`, {
            params: { query },
          });
          clientList.value = res.data;
          clientList.value.unshift({ code: "0", name: "Tous" });
        } catch (error) {
          console.error("Error fetching clients:", error);
          clientList.value = [];
        }
      }, 300); // 300ms debounce
    }

    return {
      isLoader,
      pageLength,
      loading,
      searchTerm,
      columns,
      rows,
      ZonesList,
      clientList,
      zone_filter,
      store_filter,
      UsersList,
      user_filter,
      CitiesList,
      city_filter,
      status_filter,
      status_auto_filter,
      date_filter,
      duration,
      users,
      offset,
      codeColis,
      rowNote,
      isOpen,
      myInput,
      myInputValidate,
      numberPars,
      showNote,
      onSearchUsers,
      getDate,
      resolveUserStatusVariant,
      convert,
      filter,
      Removefilter,
      handleInput,
      getRecords,
      DestroyBrc,
      RecievedBon,
      RecievedBonDirect,
      OpenBon,
      SaveBon,
      GetPDF,
      DeleteNote,
      ScanRecuColis,
      ExportNotes,
      sentNoteAuto,
      Expedier,
      auth,
      user,
      filterClients
    };
  },
});
</script>